import { BaseService } from "@services/base.service";
import { Person } from "@models/person.model";
import gateway from '@interceptors/gateway.interceptor';

class UserService extends BaseService {

    public findUserByToken = async () => {
        const url = `/gateway/user/authorities`;
        const response = await gateway.get(url);
        return response.data;
    };

    public modifyPersonById = async (id: string, person: Person) => { 
        const url = `/gateway/person/update/${id}`;
        const personDto = this.personConverter.modelToDto(person);
        const response = await gateway.put(url, personDto);
        return response.data;
    };

}
export default new UserService();